/**
 * BNPL Country Filter - Shows only payment providers available in user's country
 */

(function() {
  'use strict';

  const BNPLCountryFilter = {
    // Payment provider availability by country
    klarnaCountries: ['AT', 'BE', 'NO', 'SE', 'CH', 'DK', 'CZ', 'PL', 'FI', 'DE', 'FR', 'NL', 'IT', 'ES', 'PT', 'GR', 'RO', 'US', 'MX', 'CA', 'AU', 'NZ', 'IE', 'GB'],
    clearpayCountries: ['AU', 'NZ', 'CA', 'US', 'GB'],
    detectedCountry: null,

    init() {
      this.detectCountry().then(country => {
        this.detectedCountry = country;
        this.filterPaymentIcons();
      });
    },

    async detectCountry() {
      // Try 1: Shopify localization API
      try {
        if (window.Shopify && window.Shopify.country) {
          return window.Shopify.country;
        }
      } catch (e) {
        console.log('[BNPL Filter] Shopify.country not available');
      }

      // Try 2: Fetch from localization endpoint
      try {
        const response = await fetch('/browsing_context_suggestions.json');
        const data = await response.json();
        if (data && data.detected_values && data.detected_values.country && data.detected_values.country.handle) {
          return data.detected_values.country.handle.toUpperCase();
        }
      } catch (e) {
        console.log('[BNPL Filter] Localization API failed');
      }

      // Try 3: Session storage from previous detection
      try {
        const stored = sessionStorage.getItem('bnpl_detected_country');
        if (stored) {
          return stored;
        }
      } catch (e) {
        console.log('[BNPL Filter] Session storage not available');
      }

      // Try 4: Browser language (fallback)
      try {
        const lang = navigator.language || navigator.userLanguage;
        if (lang) {
          const countryCode = lang.split('-')[1];
          if (countryCode && countryCode.length === 2) {
            return countryCode.toUpperCase();
          }
        }
      } catch (e) {
        console.log('[BNPL Filter] Language detection failed');
      }

      // Default to GB
      console.log('[BNPL Filter] Using default country: GB');
      return 'GB';
    },

    filterPaymentIcons() {
      const country = this.detectedCountry;
      console.log('[BNPL Filter] Detected country:', country);

      // Store for future use
      try {
        sessionStorage.setItem('bnpl_detected_country', country);
      } catch (e) {}

      // Determine which providers to show
      const showKlarna = this.klarnaCountries.includes(country);
      const showClearpay = this.clearpayCountries.includes(country);
      const showPayPal = true; // Always available

      console.log('[BNPL Filter] Provider availability:', { showKlarna, showClearpay, showPayPal });

      // Filter product page icons
      const productLogos = document.querySelectorAll('.bnpl-logos .bnpl-logo');
      productLogos.forEach(logo => {
        const alt = logo.getAttribute('alt');
        if (alt === 'Klarna' && !showKlarna) {
          logo.style.display = 'none';
        } else if (alt === 'Clearpay' && !showClearpay) {
          logo.style.display = 'none';
        }
      });

      // Filter cart page icons
      const cartIcons = document.querySelectorAll('.cart__payment-icons .cart__payment-icon');
      cartIcons.forEach(icon => {
        const alt = icon.getAttribute('alt');
        if (alt === 'Klarna' && !showKlarna) {
          icon.style.display = 'none';
        } else if (alt === 'Clearpay' && !showClearpay) {
          icon.style.display = 'none';
        }
      });

      // Filter modal icons (if modal is present)
      this.filterModalIcons(showKlarna, showClearpay, showPayPal);
    },

    filterModalIcons(showKlarna, showClearpay, showPayPal) {
      // Wait for modal to be present
      const checkModal = () => {
        const modal = document.getElementById('bnpl-modal');
        if (modal) {
          const modalLogos = modal.querySelectorAll('.bnpl-logo-container');
          modalLogos.forEach(container => {
            const img = container.querySelector('img');
            if (img) {
              const alt = img.getAttribute('alt');
              if ((alt === 'Klarna' && !showKlarna) || (alt === 'Clearpay' && !showClearpay)) {
                container.parentElement.style.display = 'none';
              }
            }
          });
        }
      };

      // Check now and also when modal opens
      checkModal();
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-bnpl-trigger]')) {
          setTimeout(checkModal, 100);
        }
      });
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => BNPLCountryFilter.init());
  } else {
    BNPLCountryFilter.init();
  }

  // Expose to global scope
  window.BNPLCountryFilter = BNPLCountryFilter;
})();